import { Button, Box, Typography } from "@mui/material"
import Grid from '@mui/material/Grid';
import AccessControlRoleList from "../components/role-listview-table.component";
import { useState } from "react";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import PermissionList from "../components/permission-list.component";

const AccessControlPage = () => {

    const [selected, setSelected] = useState(false)
    const [row, setRow] = useState(null)

    return (
        <div>
           
            <Grid container spacing={2}>
                <Grid size={{ xs: 12 }}>
                    <Typography variant="body1">Permission assignment involves associating specific actions or access rights—such as read, write, update, delete, create, and execute—with defined roles.</Typography>
                </Grid>
                {selected && (
                   <Box display="flex" alignItems="center"  onClick={() => setSelected(false)} style={{ cursor: 'pointer', color: '#604CC3' }} >
                        <ArrowBackIosIcon    />
                        <Typography>
                            {row?.role}
                        </Typography>
                    </Box>
                 )}
                <Grid size={{ xs: 12 }}>
                    {!selected && (
                        <AccessControlRoleList setSelected={setSelected} setRow={setRow} />
                    )}
                    {selected && (
                        <PermissionList row={row}></PermissionList>
                    )}
                </Grid>
            </Grid>
        </div>
    )
}


export default AccessControlPage